import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addPurchaseOrderInvoiceApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const addPurchaseOrderInvoice = createAsyncThunk('addPurchaseOrderInvoice', async (payload) => {
  return await addPurchaseOrderInvoiceApi(payload);
});

const addPurchaseOrderInvoiceSlice = createSlice({
  name: 'addPurchaseOrderInvoice', // Unique Name
  initialState,
  reducers: {
    addPurchaseOrderInvoiceReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addPurchaseOrderInvoice.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(addPurchaseOrderInvoice.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(addPurchaseOrderInvoice.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { addPurchaseOrderInvoiceReset } = addPurchaseOrderInvoiceSlice.actions;

export default addPurchaseOrderInvoiceSlice.reducer;
